import React from "react";
import "../styles/WallOfFame.css";

export default function WallOfFame({ eyebrow, sub }) {
  return (
    <div className="tp-wof__grid">
      {/* Background Title */}
      <div className="tp-wof__bg-title">
        WALL
        <br />
        OF CRAFTS
      </div>

      {/* Left Tall Image */}
      <div className="tp-wof__photo tp-wof__photo--1">
        <img
          src="/Assets/walloffame/image2.jpeg"
          alt="Wall of Fame"
          loading="lazy"
        />
      </div>

      {/* Left Stacked Images */}
      <div className="tp-wof__stack tp-wof__stack--left">
        <div className="tp-wof__photo tp-wof__photo--2">
          <img
            src="/Assets/walloffame/image1.jpeg"
            alt="Wall of Fame"
            loading="lazy"
          />
        </div>

        <div className="tp-wof__photo tp-wof__photo--3">
          <img
            src="/Assets/walloffame/image3.jpeg"
            alt="Wall of Fame"
            loading="lazy"
          />
        </div>
      </div>

      {/* Center Tall Image */}
      <div className="tp-wof__photo tp-wof__photo--4">
        <img
          src="/Assets/walloffame/image4.jpeg"
          alt="Wall of Fame"
          loading="lazy"
        />
      </div>

      {/* Right Stacked Images */}
      <div className="tp-wof__stack tp-wof__stack--right">
        <div className="tp-wof__photo tp-wof__photo--5">
          <img
            src="/Assets/walloffame/image5.jpeg"
            alt="Wall of Fame"
            loading="lazy"
          />
        </div>

        <div className="tp-wof__photo tp-wof__photo--6">
          <img
            src="/Assets/walloffame/image6.jpeg"
            alt="Wall of Fame"
            loading="lazy"
          />
        </div>
      </div>

      {/* Right Tall Image */}
      <div className="tp-wof__photo tp-wof__photo--7">
        <img
          src="/Assets/walloffame/image7.jpeg"
          alt="Wall of Fame"
          loading="lazy"
        />
      </div>

      {/* Foreground Title */}
      <div className="tp-wof__title">
        <span>WALL</span>
        <span>OF CRAFTS</span>
      </div>
    </div>
  );
}
